import { useTranslation } from 'react-i18next'
import { useHomepage } from '../context/HomepageContext'
import { resolveMediaUrl } from '../utils/media'

export function useHomepageSection(key) {
  const { sections, loaded, loading } = useHomepage()
  const { t, i18n } = useTranslation()
  const section = sections[key]
  const isAr = i18n.language === 'ar'

  const pick = (en, ar) => {
    if (isAr) return ar || en || ''
    return en || ar || ''
  }

  const text = (field, fallbackKey) => {
    if (section) {
      const value = pick(section[`${field}_en`], section[`${field}_ar`])
      if (value) return value
    }
    return fallbackKey ? t(fallbackKey) : ''
  }

  const itemText = (item, field, fallbackKey) => {
    if (item) {
      const value = pick(item[`${field}_en`], item[`${field}_ar`])
      if (value) return value
    }
    return fallbackKey ? t(fallbackKey) : ''
  }

  return {
    section,
    loaded,
    loading,
    isActive: section ? section.is_active !== false : true,
    text,
    itemText,
    items: (section?.items ?? []).map((item) => ({
      ...item,
      image: item?.image ? resolveMediaUrl(item.image) : item?.image,
    })),
    settings: section?.settings ?? {},
    image: section?.image ? resolveMediaUrl(section.image) : section?.image,
    videoUrl: section?.video_url,
    buttonText: pick(section?.button_text_en, section?.button_text_ar),
    buttonLink: section?.button_link,
    buttonText2: pick(section?.button_text_2_en, section?.button_text_2_ar),
    buttonLink2: section?.button_link_2,
  }
}
